import * as Yup from 'yup';

export const readyToShipValidationSchema = Yup.object().shape({
  name: Yup.string().nullable().required('Please enter name'),
  company: Yup.string().nullable(),
  address: Yup.string().nullable().required('Please enter address Line 1').max(34, 'Address should be max 34 characters'),
  address2: Yup.string().nullable().max(34, 'Address 2 should be max 34 characters'),
  city: Yup.string().nullable().required('Please enter city'),
  phoneNumber: Yup.string().nullable().required('Please enter phone number'),
  state: Yup.string()
    .nullable().required('Please enter state code')
    .min(2, 'Must be exactly 2-letters')
    .max(2, 'Must be exactly 2-letters'),
  zip: Yup.string().zipCode().required().nullable(),
  serviceType: Yup.string().nullable().required('Please specify the service type'),
});
